module.exports = __webpack_public_path__ + "static/media/un-coupon.25b730c5.png";